'use client';
import { ErrorBoundary } from '@sentry/nextjs';
import NextErrorComponent from 'next/error';
import React from 'react';

import DeniedStoragePermisson from './denied-storage-permission';

const ErrorBoundaryComponent = ({ children }) => {
  const [errorMessage, setErrorMessage] = React.useState(
    <NextErrorComponent statusCode={500} title={'Oops an error has occoured'} />,
  );

  return (
    <ErrorBoundary
      fallback={errorMessage}
      onError={(error) => {
        if (error.message === 'storage_access_denied') {
          setErrorMessage(<DeniedStoragePermisson />);
        }
      }}>
      {children}
    </ErrorBoundary>
  );
};

export default ErrorBoundaryComponent;
